"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Modal_1 = __importDefault(require("react-bootstrap/Modal"));
var position_enum_1 = __importDefault(require("../../shared/enums/position.enum"));
var size_extra_enum_1 = __importDefault(require("../../shared/enums/size-extra.enum"));
var classMap_1 = __importDefault(require("../../shared/utilities/classMap"));
require("./modal.scss");
function Modal(props) {
    var _a, _b;
    var fullscreen = props.size === size_extra_enum_1.default.FULL;
    var showClose = (_a = props.showClose) !== null && _a !== void 0 ? _a : true;
    var hideBorders = props.hideBorders ? "border-0" : "";
    var idModal = props.id || "mpng-ux-modal-default-".concat(Date.now());
    var idTitle = "".concat(idModal, "-dialog-title");
    return (react_1.default.createElement(Modal_1.default, { id: idModal,
        className: (0, classMap_1.default)("mpng-ux-modal ", props.className),
        show: props.showModal,
        onHide: props.handleClose,
        backdrop: fullscreen ? false : ((_b = props.backdrop) !== null && _b !== void 0 ? _b : true),
        size: props.size !== "full" && props.size !== "md" ? props.size : undefined,
        centered: props.vPosition === position_enum_1.default.CENTER,
        dialogClassName: (0, classMap_1.default)(fullscreen ? "mw-100 mh-100 h-100 m-0" : undefined, props.hideBorders ? "hide-borders" : "", props.hideContainer ? "hide-container" : ""),
        animation: props.animation || true,
        scrollable: props.scrollable || false,
        backdropClassName: props.backdropClassName,
        contentClassName: (0, classMap_1.default)("mpng-ux-modal-content ", props.contentClassName),
        onEscapeKeyDown: props.handleClose, "aria-labelledby": "".concat(idModal, "-title") },
        (props.title || showClose) && (react_1.default.createElement(Modal_1.default.Header, { className: (0, classMap_1.default)(props.headerClassName, hideBorders), closeButton: showClose },
            react_1.default.createElement(Modal_1.default.Title, { className: "w-100", id: idTitle }, props.title))),
        react_1.default.createElement("div", { role: "main" },
            react_1.default.createElement(Modal_1.default.Body, { className: (0, classMap_1.default)("h-100 mh-100", props.bodyClassName) }, props.body)),
        props.footer && (react_1.default.createElement(Modal_1.default.Footer, { className: (0, classMap_1.default)(hideBorders, props.footerClassName) }, props.footer.map(function (child, key) {
            var _a;
            return (react_1.default.createElement("div", { key: (_a = child.id) !== null && _a !== void 0 ? _a : key }, child));
        })))));
}
exports.default = Modal;
